import { type MetricDataSource } from '../../types';

import type { MetricDataSourceEditorForm } from './useMetricDataSourceForm';

export function getDataSourceQuickEditSnapshot(
  dataSource:
    | Pick<MetricDataSource, 'name' | 'description' | 'archived' | 'maintainerId' | 'maintainer'>
    | Pick<MetricDataSourceEditorForm['dataSource'], 'name' | 'description' | 'archived' | 'maintainerId'>,
) {
  return {
    name: dataSource.name,
    description: dataSource.description ?? '',
    archived: dataSource.archived ?? false,
    maintainerId:
      'maintainer' in dataSource ? (dataSource.maintainerId ?? dataSource.maintainer?._id) : dataSource.maintainerId,
  };
}
